import { render } from "./FranchiseGroupAdmin.vue?vue&type=template&id=abe26c5c"
import script from "./FranchiseGroupAdmin.vue?vue&type=script&lang=js"
export * from "./FranchiseGroupAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__